import {makeAutoObservable, observable, reaction} from "mobx";
import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {Bindings} from "data/constants/bindings";
import {type IPromoBannerStore} from "data/stores/promo_banner/promo_banner.store";
import {type IRoundsStore} from "data/stores/rounds/rounds.store";

export interface IStickyBannerController extends ViewController {
	get isOpen(): boolean;
	get top(): number;

	close: () => void;
}

@injectable()
export class StickyBannerController implements IStickyBannerController {
	@observable private _isOpen = false;
	@observable private _top = 0;
	@observable private _disposer?: ReturnType<typeof reaction>;
	private bannerKey = "cfl-pck-playoff-banner";

	get isOpen() {
		return this._isOpen;
	}

	get top() {
		return this._top;
	}

	constructor(
		@inject(Bindings.PromoBannerStore) private _promoBannerStore: IPromoBannerStore,
		@inject(Bindings.RoundsStore) private _roundsStore: IRoundsStore
	) {
		makeAutoObservable(this);
	}

	close = () => {
		this._isOpen = false;

		localStorage.setItem(this.bannerKey, "true");
	};

	private listenResize = () => {
		this._top = document.querySelector<HTMLDivElement>(".prompt")?.offsetHeight || 0;
	};

	init() {
		const isShowed = JSON.parse(localStorage.getItem(this.bannerKey) || "false") as boolean;

		if (isShowed) return;

		this._isOpen = this._roundsStore.isPlayoff;

		this.listenResize();

		window.addEventListener("resize", this.listenResize);

		this._disposer = reaction(
			() => this._promoBannerStore.prompt?.show,
			() => this.listenResize()
		);
	}

	dispose() {
		window.removeEventListener("resize", this.listenResize);
		this._disposer?.();
	}
}
